export default "__VITE_ASSET__DimGTXfs__"